// This slice manages project-category items. It uses the accepted schema from
// src/lib/validation/input/project-category-schema.ts (assumed to be used for validating incoming data).

import { ProjectCategoryItem } from '@/lib/types/content/project'; // Make sure this type is defined accordingly
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProjectCategoryState {
  items: ProjectCategoryItem[]
}

const initialState: ProjectCategoryState = {
  items: [],
}

export const projectCategoriesSlice = createSlice({
  name: 'projectCategories',
  initialState,
  reducers: {
    setProjectCategories: (state, action: PayloadAction<ProjectCategoryItem[]>) => {
      state.items = action.payload
    },
    addProjectCategory: (state, action: PayloadAction<ProjectCategoryItem>) => {
      state.items.push(action.payload)
    },
    updateProjectCategory: (state, action: PayloadAction<ProjectCategoryItem>) => {
      const index = state.items.findIndex(cat => cat.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      }
    },
    removeProjectCategory: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(cat => cat.id !== action.payload)
    },
  },
})

export const {
  setProjectCategories,
  addProjectCategory,
  updateProjectCategory,
  removeProjectCategory,
} = projectCategoriesSlice.actions

export default projectCategoriesSlice.reducer
